import { ShieldX } from "lucide-react";

import { useWhoami } from "@/auth/use-whoami";
import { useDocumentTitle } from "@/lib/use-document-title";

export function ForbiddenPage() {
  const { data: whoami } = useWhoami();
  useDocumentTitle("No access");

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-24 text-center">
      <ShieldX className="text-muted-foreground size-10" />
      <h1 className="text-lg font-semibold">
        You don&apos;t have access to this page
      </h1>
      <p className="text-muted-foreground max-w-sm text-sm">
        {whoami
          ? `Your role (${whoami.role}) doesn't include the required permission. Ask a superadmin if you think you should have it.`
          : "Ask a superadmin if you think you should have access."}
      </p>
    </div>
  );
}
